import { SplitEditor } from './enum';

const generateRegexForId = (editor: SplitEditor | string, baseTestId: string): RegExp =>
  new RegExp(`^${editor}${baseTestId}\\d$`);

export const generateRegexForSplitTests = (
  editor: SplitEditor | string,
  baseSplitTestId: string,
  baseRemoveTestId: string,
  baseInputTestId?: string,
) => ({
  splitRegExp: generateRegexForId(editor, baseSplitTestId),
  removeRegExp: generateRegexForId(editor, baseRemoveTestId),
  inputRegExp: generateRegexForId(editor, baseInputTestId || ''),
});

export const BASE_SPLIT_INPUT_TEST_ID = '-split-input-';
export const BASE_SPLIT_SELECT_TEST_ID = '-split-select-';
export const BASE_SPLIT_REMOVE_TEST_ID = '-split-remove-';
export const BASE_TYPEAHEAD_SPLIT_TEST_ID = '-typeahead-split-';

export const getSplitInputTestId = (editor: string, index: number) =>
  `${editor}${BASE_SPLIT_INPUT_TEST_ID}${index}`;

export const getSplitSelectTestId = (editor: string, index: number) =>
  `${editor}${BASE_SPLIT_SELECT_TEST_ID}${index}`;

export const getSplitRemoveTestId = (editor: string, index: number) =>
  `${editor}${BASE_SPLIT_REMOVE_TEST_ID}${index}`;
